
import React, { useState, useEffect, useContext } from "react";

import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { contentContext } from "../../context/contentContext";


const Sidebar = () => {
    let { id } = useParams();
    const location = useLocation();

    const [manage, setManage] = useState(false);
    const [report, setReport] = useState(false);
    const [settings, setSettings] = useState(false);
    const [auction, setAuction] = useState(false);
    const isActive = (path) => location.pathname === path ? 'active' : '';
    // const [activeMenuObj, setActiveMenuObj] = useState({});
    const navigate = useNavigate();


    const { isLoading, setIsLoading, setActiveTab, flagg, setData, setClientInfo, clientInfo, businessData, setBusinessData, setBidsAdvSearch, setSaveLeadId, setlookUpType, setBidsSearch, setLookupSearch, setClientNameSearch, setFlagg, setActivePageName, setUserSearch, setCompanyAdvSearch, setCompanySearch, setClientMangeSearch, setDealSearch, setClientAdvSearch, setDealsAdvSearch, userData, setContent, setSearchPayload, setCategorySearch, setContentSearch, leadSearch, setFilterLeads, setLeadSearch, setActiveSearch, setUserData, activeMenuObj, setActiveMenuObj, activeMenuId, GetTimeActivity, toggleMenu, setToggleMenu, setActiveMenuId, setSortingPayload, setItemSearch } = useContext(contentContext)



    //      const handleMenu = (e, item) => {
    //          if (!isLoading && activeMenuId !== item.menuid) {
    //              setActiveTab("details")
    //              // console.log('handleMenu-------------->',item.menuid)

    //              setActiveMenuId(item.menuid)
    //              let id = item.menu.split(" ").join("").toLowerCase()
    //              GetTimeActivity()
    //              setFlagg("")
    //              setLeadSearch("")
    //              setActiveSearch("")
    //              setFilterLeads("")
    //              setContentSearch("")
    //              setCategorySearch("")
    //              setSearchPayload({})
    //              setClientAdvSearch({})
    //              setBidsSearch("")
    //              setItemSearch("");
    //              setDealSearch("")
    //              setSortingPayload("")
    //              setlookUpType("")
    //              setClientNameSearch("")
    //              setSaveLeadId("")
    //              setDealsAdvSearch({})
    //              setData([])
    //              setLookupSearch("")
    //              setClientMangeSearch("")
    //              setBidsAdvSearch({})
    //              setCompanyAdvSearch({})
    //              setCompanySearch("")
    //              setUserSearch("")
    //              setActivePageName("")
    //              setContent([])
    //              if(userData?.usertype==="BRAND MANAGER"){
    //                 setBusinessData(clientInfo)
    //              }
    //             //  if (id==="servicesconfig") {
    //             //      navigate("/settings/serviceconfig");
    //             //  } else if (id==="appconfig") {
    //             //      navigate("/settings/" + id);
    //             //  }
    //             //  else {
    //             //      navigate("/" + id);
    //             //  }
    //   navigate("/" + id);
    //          }
    //      }
    useEffect(() => {
        // clear states only after route is updated
        setLeadSearch("");
        setActiveSearch("");
        setFilterLeads("");
        setContentSearch("");
        setCategorySearch("");
        setSearchPayload({});
        setClientAdvSearch({});
        setBidsSearch("");
        setItemSearch("");
        setDealSearch("");
        setSortingPayload("");
        setlookUpType("");
        setClientNameSearch("");
        setSaveLeadId("");
        setDealsAdvSearch({});
        setData([]);
        setLookupSearch("");
        setClientMangeSearch("");
        setBidsAdvSearch({});
        setCompanyAdvSearch({});
        setCompanySearch("");
        setUserSearch("");
        setActivePageName("");
        setContent([]);
    }, [location.pathname]);
    const handleMenu = (e, item) => {
        if (!isLoading && activeMenuId !== item.menuid) {
            setActiveTab("details");
            setActiveMenuId(item.menuid);
            let id = item.menu.split(" ").join("").toLowerCase();
            setFlagg(""); // if you want to clear this immediately
            if (userData?.usertype === "BRAND MANAGER") {
                setBusinessData(clientInfo);
            }
            navigate("/" + id);
        }
    };
    function sortPermissions(permissions) {
        return permissions.sort((a, b) => a.menuid - b.menuid);
    }

    const handleActiveMenuObj = (e, name) => {
        GetTimeActivity()
        setActiveTab("details")
        setFlagg("")
        setLeadSearch("")
        setActiveSearch("")
        setFilterLeads("")
        setCategorySearch("")
        setDealsAdvSearch({})
        setContent([])
        setDealSearch("")
        setClientMangeSearch("")

        setBidsAdvSearch({})
        setClientNameSearch("")
        setLookupSearch("")
        setClientAdvSearch({})
        setCompanySearch("")
        setSearchPayload({})
        setlookUpType("")
        setCompanyAdvSearch({})
        setActivePageName("")
        setUserSearch("")
        // console.log('handleActiveMenuObj------------>',name)
        setActiveMenuObj({ ...activeMenuObj, [name]: !activeMenuObj[name] })

    }

    const handleMenuClick = (path) => {
        navigate(path);

    };
    // console.log("usertypeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",userData)
    return (


        <>

            <div className={`vertical-menu client-vertical-menu ${toggleMenu ? 'menu-show' : 'menu-hide'}`}             >

                <div data-simplebar className="h-100">

                    <div id="sidebar-menu">
                        <ul className="metismenu list-unstyled" id="side-menu">
                            {userData?.permissions?.length > 0
                                ? sortPermissions(userData.permissions).map((eachItem) => {
                                    const isDisplay = eachItem.display;
                                    const isEnable = eachItem.enable;
                                    const menuId = `sidebar-${eachItem.menu?.toLowerCase().replace(/\s+/g, '-')}`;

                                    return (
                                        <>
                                            {isDisplay && (
                                                <li
                                                    key={eachItem.menuid}
                                                    id={menuId}
                                                    className={`${eachItem.menuid === activeMenuId ? 'active' : ''} ${isLoading ? 'pe-none' : ''}`}
                                                    onClick={(e) =>
                                                        eachItem.submenus === undefined
                                                            ? handleMenu(e, eachItem)
                                                            : handleActiveMenuObj(e, eachItem.menu)
                                                    }
                                                >
                                                    <a
                                                        className={`${eachItem.submenus ? 'has-arrow' : ''} waves-effect`}
                                                    >
                                                        <i className="material-symbols-outlined">{eachItem.icon}</i>
                                                        <span>{eachItem.menu}</span>
                                                    </a>

                                                    {eachItem.submenus?.length > 0 && (
                                                        <ul
                                                            className={
                                                                activeMenuObj[eachItem.menu]
                                                                    ? 'sub-menu mm-show active'
                                                                    : 'sub-menu mm-collapse'
                                                            }
                                                            aria-expanded="false"
                                                        >
                                                            {eachItem.submenus.map((eachSubmenu) => {
                                                                const submenuId = `sidebar-${eachItem.menu
                                                                    ?.toLowerCase()
                                                                    .replace(/\s+/g, '-')}-${eachSubmenu.menu
                                                                        ?.toLowerCase()
                                                                        .replace(/\s+/g, '-')}`;
                                                                return (
                                                                    <li
                                                                        key={eachSubmenu.menuid}
                                                                        id={submenuId}
                                                                        className={`${eachSubmenu.menuid === activeMenuId ? 'active' : ''
                                                                            } ${isLoading ? 'pe-none' : ''}`}
                                                                        onClick={(e) => handleMenu(e, eachSubmenu)}
                                                                    >
                                                                        <a>{eachSubmenu.menu}</a>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    )}
                                                </li>
                                            )}
                                        </>
                                    );
                                })
                                : null}
                        </ul>

                    </div>

                    <p className="activity_time">Action: {localStorage.getItem("timeActivity")}</p>

                </div>
            </div>

        </>
    );
};

export default Sidebar;
